// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3907c2b0","732":"726d21d9"}[chunkId] + ".chunk.js";
};